/**
 * Deals — the opportunity pipeline, in the Customers panel beside the contacts
 * the deals belong to.
 *
 * One entry, one board: the pipeline is chosen on the screen rather than in the
 * sidebar, because an account runs one or two of them, not a list worth
 * navigating.
 */
export default ({ t, accountScopedRoute }) => ({
  name: 'Deals',
  label: t('OPPORTUNITIES.SIDEBAR.TITLE'),
  icon: 'i-ph-chart-line-up',
  to: accountScopedRoute('opportunities_index'),
  activeOn: ['opportunities_index'],
});
